/* ==========================================================================
   Vapor Space 2.0 — variant selection
   --------------------------------------------------------------------------
   Matches the chosen options to a variant, then updates price, stock, the
   hidden id, the gallery and the URL.

   Loaded only on the product template.
   ========================================================================== */

(function () {
  'use strict';

  var VS = (window.VS = window.VS || {});

  var section = document.querySelector('.pdp-section, .pdp');
  var dataEl = document.querySelector('[data-variant-data]');
  if (!section || !dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return; // Malformed data: leave the page as server-rendered rather than breaking it.
  }

  var idInput = section.querySelector('[data-variant-id]');
  var addButton = section.querySelector('[data-add-button]');
  var addLabel = section.querySelector('[data-add-label]');
  var priceWrap = section.querySelector('.pdp__price .price');
  var stockWrap = section.querySelector('[data-variant-stock]');

  function selectedOptions() {
    var values = [];

    VS.$$('[data-variant-option]', section).forEach(function (el) {
      var pos = parseInt(el.dataset.position, 10) - 1;

      if (el.tagName === 'SELECT') {
        values[pos] = el.value;
      } else if (el.checked) {
        values[pos] = el.value;
      }
    });

    return values;
  }

  function findVariant(values) {
    return (
      variants.filter(function (v) {
        return values.every(function (val, i) {
          return v.options[i] === val;
        });
      })[0] || null
    );
  }

  /* Which option values are purchasable given everything else chosen. Marks
     the dead ends rather than letting someone pick a flavour that cannot
     exist — 176 of 219 products here have at least one unavailable variant,
     so this is the normal case, not an edge case. */
  function markAvailability(values) {
    VS.$$('[data-variant-option]', section).forEach(function (el) {
      var pos = parseInt(el.dataset.position, 10) - 1;

      var options = el.tagName === 'SELECT' ? Array.prototype.slice.call(el.options) : [el];

      options.forEach(function (opt) {
        var trial = values.slice();
        trial[pos] = el.tagName === 'SELECT' ? opt.value : el.value;

        var match = variants.filter(function (v) {
          return trial.every(function (val, i) {
            return val == null || v.options[i] === val;
          });
        });

        var purchasable = match.some(function (v) {
          return v.available;
        });

        if (el.tagName === 'SELECT') {
          opt.disabled = false; // never block navigation to another flavour
          var base = opt.dataset.label || opt.textContent.replace(/ — .*$/, '');
          opt.dataset.label = base;
          opt.textContent = purchasable ? base : base + ' — ' + (VS.strings.soldOut || 'Sold out');
        } else {
          el.disabled = !purchasable;
        }
      });
    });
  }

  function updatePrice(variant) {
    if (!priceWrap) return;

    var current = priceWrap.querySelector('.price__current');
    var compare = priceWrap.querySelector('.price__compare');
    var save = priceWrap.querySelector('.price__save');

    if (current) current.textContent = VS.formatMoney(variant.price);

    var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

    if (compare) {
      compare.hidden = !onSale;
      if (onSale) compare.textContent = VS.formatMoney(variant.compare_at_price);
    }

    if (save) {
      save.hidden = !onSale;
      if (onSale) save.textContent = 'Save ' + VS.formatMoney(variant.compare_at_price - variant.price);
    }
  }

  function updateStock(variant) {
    if (!stockWrap) return;

    if (variant.available) {
      stockWrap.innerHTML =
        '<span class="pdp__in-stock">' + (VS.strings.inStockIcon || '') + 'In stock</span>';
    } else {
      stockWrap.innerHTML = '<span class="pdp__oos">' + (VS.strings.soldOut || 'Sold out') + '</span>';
    }
  }

  function updateGallery(variant) {
    if (!variant.featured_media) return;

    var id = String(variant.featured_media.id);
    var slide = section.querySelector('[data-media-id="' + id + '"]');
    if (!slide) return;

    VS.$$('.gallery__slide', section).forEach(function (el) {
      el.classList.toggle('is-active', el === slide);
    });

    VS.$$('[data-gallery-thumb]', section).forEach(function (t) {
      var on = t.dataset.galleryThumb === id;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  }

  function updateUrl(variant) {
    if (!window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function update() {
    var values = selectedOptions();
    markAvailability(values);

    var variant = findVariant(values);

    // Reflect the chosen value next to the option name for select-style
    // pickers, which do not otherwise show what is picked once collapsed.
    values.forEach(function (val, i) {
      var display = section.querySelector('[data-option-display="' + (i + 1) + '"]');
      if (display && val) display.textContent = val;
    });

    if (!variant) {
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = VS.strings.unavailable || 'Unavailable';
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (addButton) addButton.disabled = !variant.available;
    if (addLabel)
      addLabel.textContent = variant.available
        ? VS.strings.addToCart || 'Add to cart'
        : VS.strings.soldOut || 'Sold out';

    updatePrice(variant);
    updateStock(variant);
    updateGallery(variant);
    updateUrl(variant);
  }

  VS.$$('[data-variant-option]', section).forEach(function (el) {
    el.addEventListener('change', update);
  });

  /* --- Gallery thumbs ------------------------------------------------------ */

  VS.on('click', '[data-gallery-thumb]', function (e, thumb) {
    var id = thumb.dataset.galleryThumb;

    VS.$$('.gallery__slide').forEach(function (s) {
      s.classList.toggle('is-active', s.dataset.mediaId === id);
    });

    VS.$$('[data-gallery-thumb]').forEach(function (t) {
      var on = t === thumb;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
  });

  /* --- Quantity stepper --------------------------------------------------- */

  VS.on('click', '[data-pdp-qty]', function (e, btn) {
    var input = section.querySelector('[data-pdp-qty-input]');
    if (!input) return;

    var next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.pdpQty, 10);
    input.value = Math.max(1, next);
  });

  /* --- Add to cart --------------------------------------------------------
     Intercepted into the drawer. The form is a real product form, so with
     JavaScript off it posts normally and lands on the cart page. */

  var form = document.getElementById('vs-product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!VS.addToCart) return; // vs-cart.js absent — let it post normally
      e.preventDefault();

      var id = idInput ? idInput.value : null;
      var qtyInput = section.querySelector('[data-pdp-qty-input]');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!id) return;

      if (addButton) addButton.disabled = true;

      VS.addToCart({ items: [{ id: id, quantity: quantity }] }).finally(function () {
        if (addButton) addButton.disabled = false;
      });
    });
  }

  // Run once so availability marks are correct on first paint.
  update();
})();
